module.exports = __webpack_public_path__ + "static/media/app-dark-background.61417ac6.png";